/* ****** 接口汇总文件 ****** */
import axios from "../utils/request";
let testUrl = 'https://iot-api-test.loncinindustries.com' //测试地址（预约试驾/门店查询）
let officialUrl = 'https://iot-api.loncinindustries.com' //正式地址（预约试驾/门店查询）

let attractTestUrl = 'https://lsts.loncinindustries.com/test' //测试地址（片区招商）
let attractOfficialUrl = 'https://lsts.loncinindustries.com' //正式地址（片区招商）

let testApiKey = 'cpPB01QHNgrNQ!^PNWcaW0R!brFZl^Km' //测试apikey
let officialApiKey = 'z8Ivrea36sXg$WhDvadBKUedq0X23Pp@' //正式apiKey



/* 首页 */export const getHomeBannerApi = data => axios.get('',{ params: data })
/* 顶部搜索 */export const searchApi = data => axios.get('',{ params: data })
/* 获取省市区 */export const getAreaListApi = data => axios.get('',{ params: data })

/* 产品下拉 */export const getProductsDropDownApi = data => axios.get('',{ params: data })

/* 预约试驾页面 */
/* 根据id带出门店 */export const idOutApi = data => axios.get('',{ params:data })
/* 车型选择 */export const modelsShowApi = data => axios.get('',{ params:data })
/* 提交 */export const SubmitTestDrivesApi = data => axios.post(officialUrl+'/api/lx/sv/test-drive',data,{ headers:{'api-key':officialApiKey,'Content-Type': 'application/json;charset=utf-8'} })

/* 片区招商页面 */
/* 提交 */export const attractInvestmentApi = data => axios.post(attractOfficialUrl+'/test/api/lx/areaInvestment',data,{ headers:{'api-key':officialApiKey,'Content-Type': 'application/json;charset=utf-8'}})

/* 服务反馈页面 */
/* 车架号绑定 */export const bindVINApi = data => axios.get('',{params:data})
/* 提交 */export const feedbackSubmitApi = data => axios.get('',{params:data})
/* 门店选择 */export const storesChooseApi = data => axios.get(attractOfficialUrl+'/api/lx/use/store',{params:data,headers:{'api-key':officialApiKey}})
/* 获取七牛云token */export const uploadApi = data => axios.get('',{params:data})
/* 车架号带出车型 */ export const vinOutApi = data => axios.get(attractOfficialUrl+'/api/lx/vinInfo',{params:data,headers:{'api-key':officialApiKey}})

/* 门店查询页面 */
/*通过地名查门店*/export const getStoresApi = data => axios.get(attractOfficialUrl+'/api/lxiot-api/store-list/condition',{params:data,headers:{'api-key':officialApiKey}})

/* 产品详情 */
export const productDetailsApi = data => axios.get('',{params:data})

/* 文章列表 */
export const newsListApi = data => axios.get('',{params:data})

/* 品牌历程 */
export const courseListApi = data => axios.get('',{params:data})

/* 保养指南选择数据 */
export const maintainListApi = data => axios.get('',{params:data})

/* 维修视频列表 */
export const maintainSlectApi = data => axios.get('',{params:data})
